"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _mdiMaterialUi = require("mdi-material-ui");
var _styles = require("@material-ui/styles");
var _ChoiceItem = _interopRequireDefault(require("./ChoiceItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ChoiceItem = function ChoiceItem(_ref) {
  var _classNames, _classNames6, _classNames7, _classNames8;
  var id = _ref.id,
    group = _ref.group,
    picture = _ref.picture,
    text = _ref.text,
    onChange = _ref.onChange,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var isButton = type === 'button';
  var classes = (0, _ChoiceItem.default)();
  var theme = (0, _styles.useTheme)();
  var cssRoot = (0, _classnames.default)(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.disabled, disabled), _classNames));
  var cssField = (0, _classnames.default)(classes.field, _defineProperty({}, classes.fieldSelected, selected), _defineProperty({}, classes.fieldHorizontal, horizontal), _defineProperty({}, classes.fullWidth, fullWidth), _defineProperty({}, classes.fieldDisabled, disabled));
  var cssText = (0, _classnames.default)(classes.text, (_classNames6 = {}, _defineProperty(_classNames6, classes.textSelected, selected), _defineProperty(_classNames6, classes.textHorizontal, horizontal), _defineProperty(_classNames6, classes.textDisabled, disabled), _classNames6));
  var cssPicture = (0, _classnames.default)(classes.picture, (_classNames7 = {}, _defineProperty(_classNames7, classes.pictureDimmed, !selected && !isButton), _defineProperty(_classNames7, classes.pictureSelected, selected), _defineProperty(_classNames7, classes.pictureHorizontal, horizontal), _classNames7));
  var cssIconCheck = (0, _classnames.default)(classes.iconChecked, (_classNames8 = {}, _defineProperty(_classNames8, classes.hideCheck, isButton && !horizontal), _defineProperty(_classNames8, classes.iconCheckedHorizontal, horizontal), _defineProperty(_classNames8, classes.iconUnchecked, !selected), _defineProperty(_classNames8, classes.iconCheckedDisabled, disabled && selected), _defineProperty(_classNames8, classes.iconUncheckedDisabled, disabled && !selected), _classNames8));
  var cssTextWrapper = (0, _classnames.default)(classes.textWrapper, _defineProperty({}, classes.textWrapperHorizontal, horizontal));
  var pictureIsReactElement = /*#__PURE__*/_react.default.isValidElement(picture);
  var renderPicture = pictureIsReactElement ?
  /*#__PURE__*/
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  _react.default.cloneElement(picture, {
    disabled: disabled
  }) : picture;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cssRoot
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: id,
    className: classes.input,
    type: "radio",
    value: id,
    name: group,
    disabled: disabled,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: cssField
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: cssIconCheck
  }, selected && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Check, {
    htmlColor: theme.palette.NEUTRAL000,
    fontSize: "small"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.innerField
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cssPicture
  }, renderPicture)), /*#__PURE__*/_react.default.createElement("div", {
    className: cssTextWrapper
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: cssText
  }, text))));
};
var _default = ChoiceItem;
exports.default = _default;